import { gql } from '@apollo/client';
import { DocumentNode } from 'graphql';

export const getDeckingSection: DocumentNode = gql`
  query deckingSection($id: Int!) {
    deckingSection(id: $id) {
      depth
    }
  }
`;

export const getAncillaries: DocumentNode = gql`
  query ancillaries {
    ancillaries(filter: { available: true }, orderBy: favouriteListOrder_ASC) {
      id
      shortDescription
      longDescription
      favourite
      distributorEnabled
      unitCost
      width
      depth
      height
      treadWidth
      treadType
      modelKey
      postCentres
      isRenderable
      ancillaryType {
        id
        name
      }
      ancillaryUnit {
        id
        name
      }
    }
  }
`;
